import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React from "react";

export default function CoreRadioButton(props) {
  const {
    label,
    name,
    value,
    onChange,
    options,
    disabled,
    orientation = "horizontal",
    row,
    ...restProps
  } = props;

  const isRow = row !== undefined ? row : orientation === "horizontal";

  return (
    <FormControl component="fieldset" {...restProps}>
      {label && <FormLabel component="legend">{label}</FormLabel>}
      <RadioGroup
        aria-label={name}
        name={name}
        value={value}
        onChange={onChange}
        row={isRow}
      >
        {options &&
          options.map((option) => (
            <FormControlLabel
              key={option.id || option.value}
              value={option.id || option.value}
              control={<Radio disabled={disabled || option.disabled} />}
              label={option.label}
            />
          ))}
      </RadioGroup>
    </FormControl>
  );
}
